import ManageRow from './ManageRows';
import {
  TitleCell,
  BasedOnCell,
  TimeCell,
  CustomerTypeCell,
  AttributionModelCell,
  CadenceCell,
  LastDeliveredCell,
  ConversionCell,
  ReportManageRow,
  EmailRecipientsCell,
  DeliveryWindowCell,
  ReportTypeCell,
} from './stateless';

export const getBasicColumns = manage_params => [
  { display: 'Title', key: 'name', as: TitleCell },
  { display: 'Description', key: 'description' },
  { display: 'Based On', key: 'route', as: BasedOnCell },
  { display: 'Created', key: 'created_at', as: TimeCell },
  { headerStyles: { width: '250px' }, key: manage_params, as: ManageRow },
];

export const getScheduledReportColumns = (segments, params) => [
  { display: 'Report Name', key: 'report_name', headerWidth: 3 },
  { display: 'Conversion', key: '', as: ConversionCell(segments) },
  { display: 'Customer Type', key: 'customer_type', as: CustomerTypeCell },
  { display: 'Attribution Model', key: 'model_type', as: AttributionModelCell },
  { display: 'Cadence', key: 'cadence', as: CadenceCell },
  { display: 'Last Delivery Window', key: '', as: DeliveryWindowCell },
  { display: 'Last Delivered', key: 'last_delivered_date', as: LastDeliveredCell },
  { display: 'Email Recipients', key: 'email_recipients', as: EmailRecipientsCell, headerWidth: 3 },
  { display: '', key: params, as: ReportManageRow },
];

export const getAllReportColumns = (segments, params) => [
  { display: 'Report Name', key: 'report_name' },
  { display: 'Conversion', key: '', as: ConversionCell(segments) },
  { display: 'Customer Type', key: 'customer_type', as: CustomerTypeCell },
  { display: 'Attribution Model', key: 'model_type', as: AttributionModelCell },
  { display: 'Delivery Window', key: '', as: DeliveryWindowCell },
  { display: 'Last Delivered', key: 'delivery_timestamp', as: LastDeliveredCell },
  { display: 'Report Type', key: 'report_config_id', as: ReportTypeCell },
  { display: 'Email Recipients', key: 'email_recipients', as: EmailRecipientsCell, headerWidth: 3 },
  { display: '', key: params, as: props => ReportManageRow({ ...props, showDelete: false }) },
];
